// 🔥 공통 URL 설정 유틸리티
// 모든 컴포넌트에서 사용할 수 있는 통합된 URL 설정

/**
 * 환경별 baseURL 반환
 * @returns {string} 환경에 따른 baseURL
 */
export function getBaseURL() {
    const hostname = window.location.hostname;
    const isAdminPage = window.location.pathname.startsWith('/admin');

    console.log('🌐 URL 설정 - 호스트:', hostname, '관리자페이지:', isAdminPage);

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        console.log('🔧 로컬 개발 환경 감지');
        return process.env.VUE_APP_API_URL || 'http://localhost:8080';
    } else if (hostname === '13.125.214.191') {
        console.log('🚀 EC2 IP 직접 접속 감지');
        return 'http://13.125.214.191:8080';
    } else if (hostname.includes('doctormarket.co.kr')) {
        // 🔥 co.kr 접속자는 co.kr API를 그대로 호출 (같은 도메인 유지)
        console.log('🌍 도메인 접속 감지 - co.kr');
        return 'https://doctormarket.co.kr';
    } else if (hostname.includes('doctormarket.kr')) {
        console.log('🌍 도메인 접속 감지');
        return process.env.VUE_APP_API_URL || 'https://doctormarket.kr';
    } else {
        console.log('🔧 기타 환경 감지');
        return process.env.VUE_APP_FALLBACK_API_URL || 'http://13.125.214.191:8080';
    }
}

/**
 * API 엔드포인트 URL 생성
 * @param {string} endpoint - API 엔드포인트 경로
 * @returns {string} 완전한 API URL
 */
export function getApiUrl(endpoint) {
    const baseURL = getBaseURL();
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${baseURL}${cleanEndpoint}`;
}

/**
 * 이미지 URL 생성
 * @param {string} imagePath - 이미지 경로
 * @returns {string} 완전한 이미지 URL
 */
export function getImageUrl(imagePath) {
    if (!imagePath) return '';

    if (imagePath.startsWith('http')) {
        return imagePath;
    }

    const baseURL = getBaseURL();
    const cleanPath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
    return `${baseURL}${cleanPath}`;
}

/**
 * 이미지 URL을 현재 환경에 맞게 정규화
 * @param {string} imageUrl - 원본 이미지 URL
 * @returns {string} 정규화된 이미지 URL
 */
export function normalizeImageUrl(imageUrl) {
    if (!imageUrl) return '';

    // 이미 완전한 URL인지 확인
    if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://') || imageUrl.startsWith('data:')) {
        // 하드코딩된 도메인 URL을 상대 경로로 변환
        if (imageUrl.includes('doctormarket.kr')) {
            try {
                const urlObj = new URL(imageUrl);
                return urlObj.pathname;
            } catch (error) {
                console.warn('URL 파싱 실패:', imageUrl);
                return imageUrl;
            }
        }
        return imageUrl;
    }

    // 상대 경로인 경우 그대로 반환
    return imageUrl;
}